import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput"
import ParadigmaEditor from '../../../components/ParadigmaEditor/ParadigmaEditor';

import { Row, Col } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        };

        this.getData = this.getData.bind(this);
    }

    static propTypes = {
        onSubmit: PropTypes.func,        
        nav: PropTypes.any
    }

    getData() {
        const { descripcion, asunto, cuerpo } = this.state;
        return {
            descripcion,
            asunto,
            cuerpo
        };
    }

    resetForm() {
        this.setState({
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        });
        if (this.props.onClose) this.props.onClose();
    }


    onCuerpoChange = html => this.setState({ cuerpo: html });

    render() {
        return (
            <span>
            <ParadigmaModal
                onPreSubmit={this.getData}
                postUrl={api.email.plantillas.create}
                navButton={(this.props.nav ? true : false)}
                nav={this.props.nav}
                onSubmit={(e) => this.props.onSubmit(e)}
                successMessage={"La Plantilla de Mail ha sido generada con éxito."}
                title={"Nueva Plantilla de Mail"}
                buttonTitle={"Nueva"}
                className={"modal-lg"}
                buttonIcon={"fa fa-plus fa-lg"}
                saveButton={true}
                closeButton={true}
                onClose={() => this.resetForm()}
                initOpen={this.props.initOpen}
                backdrop={false}
                cancelButtonLabel="Cancelar"
            >

                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Descripción"}
                            fieldName={"descripcion"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.descripcion}
                            onChange={e => this.setState({ descripcion: e.target.value })}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col className="col-12 col-separator">Mail</Col>
                </Row>



                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Asunto"}
                            fieldName={"asunto"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.asunto}
                            onChange={e => this.setState({ asunto: e.target.value })}
                        />
                    </Col>
                </Row>

                <Row className="my-4 mx-0">
                    <Col className="px-0">

                        <ParadigmaEditor
                            value={this.state.cuerpo}
                            onChange={this.onCuerpoChange}
                        />

                    </Col>
                </Row>

            </ParadigmaModal>
            </span>
        );
    }
}

export default Create;


// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Create.js